import { Mesh, type Object3D } from 'three'
import { toCreasedNormals } from 'three/examples/jsm/utils/BufferGeometryUtils.js'

export default function creaseGeometryNormalsForTraverse(
  obj: Object3D,
): void {
  if (obj instanceof Mesh) {
    obj.geometry = toCreasedNormals(obj.geometry)
  }
}
